import url from "../../config/url";

const URL = `${url}scada/records-by-column`;

async function getPlcRecordsByColumn({
  idPlanta,
  column,
  fechaInicio,
  fechaFin,
  recordsAmount = 100
}) {
  try {
    const response = await fetch(URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",

        // Header requerido por CodeIgniter (access_app)
        "api-key": process.env.REACT_APP_API_KEY,

        // Compatibilidad si el backend usa este nombre
        "X-Api-Key": process.env.REACT_APP_API_KEY
      },
      body: JSON.stringify({
        idPlanta,
        column,
        fechaInicio,
        fechaFin,
        recordsAmount
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data?.error || "Failed to fetch records");
    }

    return data;
  } catch (error) {
    console.error("Error fetching records:", error);
    throw error;
  }
}

export { getPlcRecordsByColumn };
